<template>
  <div class="fullEditor">
    <Editor
      v-model="$v[validationGroupName].sections.letter.$model"
      @blur="$v[validationGroupName].sections.letter.$touch()"
      :validator="$v[validationGroupName].sections.letter"
      :showDebugger="false"
      :disabled="isCompletedQuote" />
  </div>
</template>

<script>
import Editor from '@/components/_shared/Editor.vue'

export default {
  name: 'TabLetter',
  inject: ['$v'],
  components: { Editor },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    }
  }
}
</script>
